module.exports = __webpack_public_path__ + "img/logofree.23e19be6.png";